import { createContext } from 'react';

export const IsDemo = createContext(false);
